// import {useState} from 'react'
import {Input} from 'antd'
import cn from 'clsx'
import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
// import {/*useGetAllUsers,*/ User} from 'modules/users'
// import {useGetProfile} from 'modules/profile'
// import {BorrowerForm} from 'modules/users/components'
import {
  // ButtonLink,
  Box,
  Button,
  Form,
  FormItem,
  ImageUpload,
  // Select,
  // UserItem,
  // Modal,
} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES} from 'common/constants'
import {RequestTabFormProps} from '..'

// interface SelectManagerProps {
//   managers: User[]
// }

export default function RequestAboutForm({
  form,
  clickedTab,
  newRequest,
  isRequestCreating,
  setNewRequest,
  setTab,
  setClickedTab,
  onClose
}: RequestTabFormProps) {
  const role = useStore((state) => state.role)
  const isNotManager = (!role.manager && !role['associated-manager'])
  // console.log(isNotManager)

  // const {data: profile} = useGetProfile({enabled: role['associated-manager']})
  const inputRef = useInputFocus(500)

  const handleFinish = (values: any) => {
    // console.log(values)
    const newRequestExtended = {...newRequest, ...values, aboutFormSubmit: true}
    // console.log(newRequestExtended)
    setNewRequest(newRequestExtended)
    setTab(clickedTab)
  }

  const handleSubmitClick = () => setClickedTab('loan')

  const initialValues = {
    title: newRequest.title,
    image: newRequest.image,
    // region: newRequest.region,
    address: newRequest.address,
    description: newRequest.description,
    borrower: newRequest.borrower,
    borrowerBackground: newRequest.borrowerBackground,
    // lendingManager: newRequest.lendingManager,
    borrowerName: newRequest.borrowerName,
    borrowerEmail: newRequest.borrowerEmail,
    borrowerPhoneNumber: newRequest.borrowerPhoneNumber,
  }

  return (
    <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
      <FormItem name="title" label="Project name" rules={FIELD_RULES}>
        <Input ref={inputRef} size="large" />
      </FormItem>
      <FormItem name="image" label="Project image" rules={FIELD_RULES}>
        <ImageUpload />
      </FormItem>
      {/* <FormItem name="region" label="Project region" rules={FIELD_RULES}>
        <Select options={regionOptions} />
      </FormItem> */}
      <FormItem name="address" label="Project address" rules={FIELD_RULES}>
        <Input />
      </FormItem>
      <FormItem name="description" label="Project details" rules={FIELD_RULES}>
        <TextArea rows={4} />
      </FormItem>
      {/* {!role.user && !role.broker && <SelectUser />} */}
      { isNotManager &&
        <>
        <FormItem name="borrowerName" label="Borrower name" rules={FIELD_RULES}>
          <Input />
        </FormItem>
        <FormItem name="borrowerEmail" label="Borrower Email" rules={FIELD_RULES}>
          <Input />
        </FormItem>
        <FormItem name="borrowerPhoneNumber" label="Borrower phone number" rules={FIELD_RULES}>
          <Input />
        </FormItem>
        </>
      }
      <FormItem
        name="borrowerBackground"
        label={`${/*role.user ? 'Your' : */'Borrower'} background`}
        rules={FIELD_RULES}
      >
        <TextArea rows={4} />
      </FormItem>
      {/* {role['associated-manager'] && profile.managedUsers.length > 1 && (
        <SelectManager managers={profile.managedUsers} />
      )} */}
      <Box align="right">
        <Button
          className={cn(
            commonStyles.button,
            'Button_type_form',
            'Button_type_form_cancel',
          )}
          loading={isRequestCreating}
          onClick={onClose}
        >
          Cancel
        </Button>
        &nbsp;
        <Button
          className={cn(
            commonStyles.button,
            'Button_type_form',
            'Button_type_form_submit',
          )}
          htmlType="submit"
          loading={isRequestCreating}
          onClick={handleSubmitClick}
        >
          Next
        </Button>
      </Box>
    </Form>
  )
}

// const SelectUser = () => {
//   const {data: borrowers, isLoading} = useGetAllUsers('borrowers', 'user')
//   const [isSelectOpen, setSelectOpen] = useState(false)
//   const [isModalOpen, setModalOpen] = useState(false)

//   const handeSelectOpenSet = (open: boolean) => setSelectOpen(open)

//   const handleModalOpen = () => {
//     setSelectOpen(false)
//     setModalOpen(true)
//   }

//   const handleModalClose = () => setModalOpen(false)

//   const borrowerOptions = borrowers
//     ? borrowers
//         .filter((borrower) => borrower.firstName || borrower.lastName)
//         .map((borrower) => ({
//           value: borrower.uuid,
//           label: <UserItem user={borrower} />,
//           textLabel: `${borrower.firstName} ${borrower.lastName}`,
//         }))
//     : []

//   return (
//     <FormItem
//       name="borrower"
//       label="Assign borrower or invite user via email"
//       rules={FIELD_RULES}
//     >
//       <Select
//         showSearch
//         placeholder="Search user"
//         optionFilterProp="textLabel"
//         loading={isLoading}
//         options={borrowerOptions}
//         open={isSelectOpen}
//         dropdownRender={(menu) => (
//           <>
//             {menu}
//             <>
//               <Box pl={16} mt={12}>
//                 <ButtonLink onClick={handleModalOpen}>Create user…</ButtonLink>
//               </Box>
//               <Modal
//                 title="Add new borrower"
//                 open={isModalOpen}
//                 onCancel={handleModalClose}
//               >
//                 <BorrowerForm onClose={handleModalClose} />
//               </Modal>
//             </>
//           </>
//         )}
//         onDropdownVisibleChange={handeSelectOpenSet}
//       />
//     </FormItem>
//   )
// }

// const SelectManager = ({managers}: SelectManagerProps) => {
//   const managerOptions = managers
//     ? managers.map((manager) => ({
//         value: manager.uuid,
//         label: <UserItem user={manager} />,
//       }))
//     : []

//   return (
//     <FormItem name="lendingManager" label="Select manager" rules={FIELD_RULES}>
//       <Select options={managerOptions} />
//     </FormItem>
//   )
// }

const {TextArea} = Input

// const regionOptions = [
//   'Auckland',
//   'Bay of Plenty',
//   'Canterbury',
//   'Christchurch',
//   'Coromandel',
//   'Dunedin',
//   'Eastland',
//   'Fiordland',
//   'Gisborne',
//   "Hawke's Bay",
//   'Manawatu Whanganui',
//   'Marlborough',
//   'Mt Cook',
//   'Nelson',
//   'Northland',
//   'Otago',
//   'Queenstown',
//   'Rotorua',
//   'Ruapehu',
//   'Southland',
//   'Taranaki',
//   'Tasman',
//   'Taupo',
//   'Waikato',
//   'Wairarapa',
//   'Wanaka',
//   'Wellington',
//   'West Coast',
// ].map((item) => ({
//   value: item,
//   label: item,
// }))
